module.exports = __webpack_public_path__ + "assets/img/23_130.52c2f962.jpg";